import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import { ScreenReaderText } from '@atlassian/jira-accessibility/src/common/ui/screenreader-text/index.tsx';
import SearchField from '@atlassian/jira-common-components-filter-search/src/main.tsx';
import { Skeleton } from '@atlassian/jira-common-components-skeleton/src/styled.tsx';
import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import { searchMessage } from './messages';
import type { TextFilterContainerProps } from './types';

export const TextFilterContainer = (props: TextFilterContainerProps) => {
	const { searchText, onTextChange, isFetching, intl } = props;
	const screenReaderDescriptionId = 'access-search-field-description';

	if (isFetching === true) {
		return (
			<TextWrapper>
				<Skeleton height="32px" />
			</TextWrapper>
		);
	}
	return (
		<TextWrapper>
			<ScreenReaderText id={screenReaderDescriptionId}>
				{intl.formatMessage(searchMessage.screenReaderInstruction)}
			</ScreenReaderText>
			<SearchField
				describedById={screenReaderDescriptionId}
				value={searchText}
				onChange={onTextChange}
				isCompact
				placeholderAlwaysVisible
				shouldFitContainerWidth
				placeholder={intl.formatMessage(searchMessage.searchRolesPlaceholder)}
			/>
		</TextWrapper>
	);
};
TextFilterContainer.defaultProps = {
	isFetching: false,
};

export default injectIntl(TextFilterContainer);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TextWrapper = styled.div<{
	children?: ReactNode;
}>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${gridSize * 42}px`,
});
